import React from 'react';
import { TextField, Button } from '@material-ui/core';
import load from 'load-script';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import axiosI from '../../../../Service/service';
import {userCheckIn, userCheckOut} from '../../../../Actions/index';
import {addressUpdated} from '../../../../Actions/myAccountAction';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import * as constants from '../../../../Constants';

class ChangeLocation extends React.Component{
    constructor() {
        super();
        this.state={
            newAddress: "",
            newAddressError:false,
            addressData:{},
            error:false,
            errorMessage:"",
            loadAutocomplete:false
        };
    }
    componentDidMount() {
      load('https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyBr9MSaEjodT_Q9bnUqUcusJ8HWmQmJRC0', () => {
        this.setState({
          loadAutocomplete: true
        })
      })
    }

    textChange = (value) => {
        this.setState({
            newAddress:value
        });
    };

    handleSelect = address => {
        let { addressData } = this.state;
        let newAddress
        addressData['BusinessName'] = address.substring(0, address.indexOf(','));
        if(address.trim().length > 40) {
            newAddress= address.substring(0, 40) + " ...";
        }
        else {
            newAddress= address;
        }
        geocodeByAddress(address)
            .then(results => {
                addressData['PlaceID']= results[0].place_id;
                addressData['Address']= results[0].formatted_address;
                addressData['Address_Type']= results[0].types.join();
                getLatLng(results[0]).then(latLng => {
                    addressData['Address_Lat']= latLng.lat.toFixed(5);
                    addressData['Address_Long']= latLng.lng.toFixed(5);
                    this.setState({ addressData });
                })
            })
            .catch(error => console.error('Error', error));
        this.setState({ newAddress });
    };

    validateAddress = () => {
        let error
        let errorMessage
        error = this.state.addressData.PlaceID.toUpperCase() !== this.props.user.BusinessUser.PlaceID.toUpperCase();
        errorMessage = "Request business can't found with this address!!";
        this.setState({
            error,
            errorMessage
        });
    };

    updateAddress = () => {
        const {user} = this.props;
        let {addressData, error, errorMessage} = this.state;
        let proceed = this.state.addressData.PlaceID.toUpperCase() !== this.props.user.BusinessUser.PlaceID.toUpperCase();
        if(proceed) {
            let data={
                BusinessId: user.BusinessUser.BusinessId,
                BusinessName: addressData['BusinessName'],
                PlaceID: addressData['PlaceID'],
                Address: addressData['Address'],
                Address_Type:addressData['Address_Type'],
                Address_Lat: addressData['Address_Lat'],
                Address_Long: addressData['Address_Long']
            };
            axiosI.post(constants.API.updateBusinessAddressApi,data).then((response)=>{
                if(response.data.results.ResponseCode) {
                    error = false;
                    this.props.showAlert(true,'Address changed successfully.');
                    this.props.handleOpen();

                    let data = {
                        GooglePlaceId:this.props.user.BusinessUser.PlaceID,
                        UserId: this.props.user.AppUser.UserId
                    };
                    //console.log(data);

                    if(addressData['PlaceID']) {
                        let checkIndata = {
                            "Address": addressData['Address'],
                            "GooglePlaceId": addressData['PlaceID'],
                            "Latitude": addressData['Address_Lat'],
                            "Longitude": addressData['Address_Long'],
                            "PageNumber": 1,
                            "PageSize": 15,
                            "PlaceName": addressData['BusinessName'],
                            "PlaceType": addressData['Address_Type'],
                            "UserId": this.props.user.AppUser.UserId
                        };
                        userCheckIn(checkIndata);
                    }

                    userCheckOut(data);

                    //this.props.addressUpdated(addressData);

                }
                else {
                    errorMessage = response.data.results.Message;
                    error = true;
                    this.setState({ error, errorMessage });
                }
            }).catch((err)=>{
                console.log(err);
            })
        }
    };

    render() {
        const { classes } = this.props;
        const { newAddressError, newAddress, error, errorMessage } = this.state;
        return(
            <React.Fragment>
              {this.state.loadAutocomplete && <div className="control-wrapper">
                    {error && <span style={{color:'red'}}>{errorMessage}</span>}
                    <PlacesAutocomplete
                        value={newAddress}
                        onChange={this.textChange}
                        onSelect={this.handleSelect}
                    >
                        {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                            <div>
                                <TextField
                                    {...getInputProps({
                                        margin:"normal",
                                        placeholder:"Search for my business",
                                        inputProps:{className: classes.inputText},
                                        fullWidth:true
                                    })}
                                />
                                <div>
                                    {suggestions.map(suggestion => {
                                        const className = suggestion.active
                                            ? 'suggestion-item'
                                            : 'suggestion-item';
                                        const style = suggestion.active
                                            ? { color: 'black', cursor: 'pointer' }
                                            : {  color: 'black',cursor: 'pointer' };
                                        return (
                                            <div
                                                {...getSuggestionItemProps(suggestion, {
                                                    className,
                                                    style,
                                                })}
                                            >
                                                <span>{suggestion.description}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </PlacesAutocomplete>
                    {newAddressError &&
                    <span style={{color: 'red'}}>Password must be 8-16 characters long and cannot contain space.</span>}
                    <div className="update-password-btn">
                        <Button className="update-password-button" onClick={this.updateAddress}>Update My Location</Button>
                    </div>
                </div>}
            </React.Fragment>
        )
    }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        addressUpdated
    },dispatch)
};

export default connect(null, matchDispatchToProps)(ChangeLocation);
